import request from '@/utils/request'

export function verify(data) {
  return request({
    url: 'api/auth/VerifyParams',
    method: 'post',
    data
  })
}

export function changeCountry(country) {
  return request({
    url: 'api/auth/ChangeCountry?country='+country,
    method: 'post',
  })
}